import {
  Ionicons,
  MaterialCommunityIcons,
  MaterialIcons,
  Feather,
  FontAwesome,
  AntDesign,
  Entypo,
} from '@expo/vector-icons';
import * as Font from 'expo-font';
import * as SplashScreen from 'expo-splash-screen';
import * as React from 'react';

export default function useCachedResources() {
  const [isLoadingComplete, setLoadingComplete] = React.useState(false);

  // Load any resources or data that we need prior to rendering the app
  React.useEffect(() => {
    async function loadResourcesAndDataAsync() {
      try {
        SplashScreen.preventAutoHideAsync();

        // Load fonts
        await Font.loadAsync({
          ...Ionicons.font,
          ...MaterialCommunityIcons.font,
          ...MaterialIcons.font,
          ...Feather.font,
          ...FontAwesome.font,
          ...AntDesign.font,
          ...Entypo.font,
          'space-mono': require('../assets/fonts/SpaceMono-Regular.ttf'),
          'lato-black': require('../assets/fonts/Lato-Black.ttf'),
          'lato-bold': require('../assets/fonts/Lato-Bold.ttf'),
          'lato-blackI': require('../assets/fonts/Lato-BlackItalic.ttf'),
          'lato-medium': require('../assets/fonts/Lato-Medium.ttf'),
          lato: require('../assets/fonts/Lato-Regular.ttf'),
          'lato-heavy': require('../assets/fonts/Lato-Heavy.ttf'),
          'poppins-thin': require('../assets/fonts/Poppins-Thin.ttf'),
          'poppins': require('../assets/fonts/Poppins-Regular.ttf'),
          'poppins-bold': require('../assets/fonts/Poppins-Bold.ttf'),
          'poppins-medium': require('../assets/fonts/Poppins-Medium.ttf'),
          'poppins-light': require('../assets/fonts/Poppins-ExtraLight.ttf'),
          'roboto-light': require('../assets/fonts/Roboto-Light.ttf'),
        });
      } catch (e) {
        // We might want to provide this error information to an error reporting service
        console.warn(e);
      } finally {
        setLoadingComplete(true);
        SplashScreen.hideAsync();
      }
    }

    loadResourcesAndDataAsync();
  }, []);

  return isLoadingComplete;
}
